import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'
import { orderPropType } from '../orders/order-prop-type'
import { routeParametersPropType } from '../route/route-parameters-prop-type'
import { addressPropType } from '../address/address-prop-type'

/**
 * This is the orderTourPropType data model type definition.
 *
 * @typedef {Object} OrderTour
 * @property {boolean} [isRoundTrip] - round trip flag
 * @property {number} [lastModified] - timestamp of last change.
 * @property {Id} [lastModifiedUserId] - user id of last change.
 * @property {Id} [objectId] - vehicle identifier for the vehicle the order is assigned to.
 * @property {Order[]} [orders] - list of orders in the tour.
 * @property {Id} [orderSchedulesId] - the id of the order tour.
 * @property {RouteParameter} [routeParameters]
 * @property {Address} [startLocation] - The address of the start location of the tour.
 * @property {string} [startTime] - start time of the tour.
 */
export const orderTourPropType = PropTypes.shape({
    isRoundTrip: PropTypes.bool,
    lastModified: PropTypes.number,
    lastModifiedUserId: idPropType,
    objectId: idPropType,
    orderSchedulesId: idPropType,
    orders: PropTypes.arrayOf(orderPropType),
    routeParameters: routeParametersPropType,
    startLocation: addressPropType,
    startTime: PropTypes.string
})
